import { render } from "./ModalOrganizationCreateComplete.vue?vue&type=template&id=1ed2bcea&scoped=true"
import script from "./ModalOrganizationCreateComplete.vue?vue&type=script&lang=js"
export * from "./ModalOrganizationCreateComplete.vue?vue&type=script&lang=js"

import "./ModalOrganizationCreateComplete.vue?vue&type=style&index=0&id=1ed2bcea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed2bcea"]])

export default __exports__